import { render, staticRenderFns } from "./_certificat.vue?vue&type=template&id=aba9b8b6&scoped=true"
import script from "./_certificat.vue?vue&type=script&lang=js"
export * from "./_certificat.vue?vue&type=script&lang=js"
import style0 from "./_certificat.vue?vue&type=style&index=0&id=aba9b8b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba9b8b6",
  null
  
)

export default component.exports